module.exports = "/_next/static/images/ee8c351d11d2ad4bb23361995d0d2891-mastercard.jpg";